import FakturaceNahledPolozka from "./FakturaceNahledPolozka";

export default class FakturaceNahled {

    public totalPrice: number = 0;
    public items: FakturaceNahledPolozka[] = [];

    public clone(): FakturaceNahled {
        const newDen: FakturaceNahled = new FakturaceNahled();
        newDen.loadFromEntity(this);
        return newDen;
    }

    public loadFromJSON(json: any): FakturaceNahled {
        this.totalPrice = json.totalPrice;
        if(json.humanReadableLines != null) {
            json.humanReadableLines.forEach(line => {
                const polozka = new FakturaceNahledPolozka();
                polozka.name = line.name;
                polozka.price = line.unit_price;
                this.items.push(polozka);
            });
        }
        return this;
    }

    public loadFromEntity(ent: FakturaceNahled): FakturaceNahled {
        throw new Error("Not implemented")
    }

}


// WEBPACK FOOTER //
// ./src/models/FakturaceNahled.tsx